module.exports = __webpack_public_path__ + "static/media/IMG_0281.c89dfbef.jpg";